import { useI18n } from '../../i18n'
import {
   closeMeasurementEditModal,
   editingMeasurementDistance,
   editingMeasurementDuration,
   editingMeasurementTimestamp,
   isMeasurementEditModalOpen,
   measurementEditError,
   saveEditedMeasurement,
   setEditingMeasurementDistance,
   setEditingMeasurementDuration,
   setEditingMeasurementTimestamp,
} from '../../state/measurementEditStore'
import EditEntryModal from './EditEntryModal'
import DateTimeField from '../ui/DateTimeField'
import DurationInput from '../ui/DurationInput'
import FieldLabel from '../ui/FieldLabel'
import QuantityField from '../ui/QuantityField'

/**
 * Renders the exercise-entry edit modal (distance, duration, timestamp).
 *
 * @returns The modal element.
 */
const MeasurementEditModal = () => {
   const t = useI18n()

   return (
      <EditEntryModal
         id="measurement-edit-modal"
         open={isMeasurementEditModalOpen()}
         title={t('Edit entry')}
         error={measurementEditError()}
         saveId="measurement-edit-save-btn"
         cancelId="measurement-edit-cancel-btn"
         onSave={saveEditedMeasurement}
         onCancel={closeMeasurementEditModal}
      >
         <QuantityField
            id="measurement-edit-distance"
            quantity="distance"
            label={unit => t('Distance ({unit})', { unit })}
            step="0.01"
            value={editingMeasurementDistance()}
            onValueInput={setEditingMeasurementDistance}
         />
         <div>
            <FieldLabel for="measurement-edit-duration">{t('Time (m:ss)')}</FieldLabel>
            <DurationInput
               id="measurement-edit-duration"
               value={editingMeasurementDuration()}
               onValueInput={setEditingMeasurementDuration}
            />
         </div>
         <DateTimeField
            id="measurement-edit-time"
            label={t('Date and time')}
            value={editingMeasurementTimestamp()}
            onValueInput={setEditingMeasurementTimestamp}
         />
      </EditEntryModal>
   )
}

export default MeasurementEditModal
